(function () {
  function getScrollTop() {
    var pageWrapper = document.querySelector('.page-wrapper');
    return Math.max(
      window.scrollY || 0,
      document.documentElement.scrollTop || 0,
      document.body.scrollTop || 0,
      pageWrapper ? pageWrapper.scrollTop : 0
    );
  }

  function getTriggerHeight(selector) {
    if (!selector) {
      return 0;
    }

    var parts = String(selector)
      .split(',')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);

    for (var i = 0; i < parts.length; i += 1) {
      var node = document.querySelector(parts[i]);
      if (node instanceof HTMLElement) {
        return node.offsetHeight || 0;
      }
    }

    return 0;
  }

  function initSticky(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[data-landing-sticky]');

    nodes.forEach(function (sticky) {
      if (sticky.dataset.stickyReady === 'true') {
        return;
      }
      sticky.dataset.stickyReady = 'true';

      var toggle = sticky.querySelector('[data-sticky-toggle]');
      var triggerSelector = sticky.dataset.triggerSelector || '';
      var fallbackOffset = Number.parseFloat(sticky.dataset.scrollOffset || '400');
      var pageWrapper = document.querySelector('.page-wrapper');

      function updateVisibility() {
        var triggerHeight = getTriggerHeight(triggerSelector);
        var threshold = triggerHeight > 0 ? triggerHeight : fallbackOffset;
        var shouldShow = getScrollTop() >= threshold;

        sticky.classList.toggle('is-collapsed', !shouldShow);
      }

      function onToggle(event) {
        event.preventDefault();
        var isClosed = sticky.classList.toggle('is-closed');
        if (toggle) {
          toggle.setAttribute('aria-expanded', isClosed ? 'false' : 'true');
        }
      }

      if (toggle) {
        toggle.addEventListener('click', onToggle);
      }

      window.addEventListener('scroll', updateVisibility, { passive: true });
      if (pageWrapper) {
        pageWrapper.addEventListener('scroll', updateVisibility, { passive: true });
      }
      window.addEventListener('resize', updateVisibility, { passive: true });

      updateVisibility();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSticky(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSticky(document);
    });
  } else {
    initSticky(document);
  }
})();
